<template lang="pug">
b-modal#editMarquee(
  ref="editMarquee"
  :title="$t('ui.edit_marquee')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="md"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row
      .col-sm-12.col-md-6.col-lg-12
        b-form-group(:label="$t('ui.marquee_content')")
          b-form-textarea(
            ref="marquee_content"
            size="sm"
            required
            :dirty="$v.marquee_content.$dirty"
            :error="$v.marquee_content.$error"
            v-model.trim.lazy="$v.marquee_content.$model"
            rows="10"
            max-rows="10"
            trim=true
            :disabled="loading"
          )
        ValidateResult(:value="$v.marquee_content" :name="$t('ui.marquee_content')")        
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      marquee_content: ""
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
  },
  validations: {
    marquee_content: {
      required,
      maxLength: maxLength(1000)
    }
  },
  watch: {  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.marqueeEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          marquee_content: this.marquee_content
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editMarquee.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_marquee", this.feedback.status);
                  this.$refs.editMarquee.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.marquee_content = this.item.marquee_content;
      this.$refs.marquee_content.$el.focus();
    }
  },
};
</script>
